import globalStore from '$$globalStore';
import teamModel from '../../../models/team';
import app from '$$app';

function onTeamUpdated({ event, data: { updated } }) {
  updated.forEach(update => {
    const { updatedFields } = update;

    if (updatedFields.name) {
      teamModel.changeTeamName(updatedFields.name);
    }

    if (updatedFields.isActiveCurrency !== undefined) {
      globalStore.commit('teamSetting/setEnableCurrency', updatedFields.isActiveCurrency, { root: true });
      globalStore.commit('teamSetting/setCurrency', updatedFields.currency, { root: true });
    }
  });

  app.trigger('onAfterCollaboration', {
    event,
  });
}

export default onTeamUpdated;
